var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex"},[_c('LinkEntity',{attrs:{"payload":_vm.payload.resources.applicant}}),_c('LinkEntity',{attrs:{"payload":_vm.payload.resources.position,"additional_data":{ resource_type: 'Position' }}}),_c('LinkEntity',{attrs:{"payload":_vm.payload.resources.company}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }